import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    gridContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    gridItem: {
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc',
        borderRadius: 5,
        margin: 10,
        padding: theme.spacing(2)
    },
    finishBtn: {
        margin: '40px auto 20px',
        display: 'flex'
    }
}))